import React, { useEffect, useState } from "react";
import { Tabs, Tab, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { GoAlert } from "react-icons/go";
import { useFormik } from "formik";
import * as Yup from "yup";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import HtmlEditor from "../../../../components/UI/HtmlEditorInput/HtmlEditor";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import ListaAlteracaoExecutor from "./ListaAlteracaoExecutor";
import useAssinarAltExecutor from "../hooks/useAssinarAltExecutor";
import useExcluirAlteracao from "../hooks/useExcluirAlteracao";

const validationSchema = Yup.object().shape({
  totalExecutores: Yup.number().default(0),
  totalExecutoresIncluidos: Yup.number().default(0),
  totalExecutoresExcluidos: Yup.number().default(0),
  listaExecutoresOs: Yup.array()
    .default([])
    .test("qt-executor", "Selecione pelo menos 1 executor", (value) => {
      if (value.length === 0) return false;
      return true;
    }),
  textoJustificativa: Yup.string()
    .nullable()
    .default("")
    .test("qtd-justify", "Informe a justificativa para a alteração de executor.", (value) => {
      if (value === "" || value === "<p><br></p>" || value === null) return false;
      return true;
    }),
});

const initialValues = {};
validationSchema._nodes.forEach((key) => {
  if (key === "listaExecutoresOs") {
    initialValues[key] = [];
  } else {
    initialValues[key] = "";
  }
});

const TelaAlteraExecutorOs = ({ dadosOs, sqAlteracaoExecutor, dadosAltExec, sgAtividade, limparTela }) => {
  const [alteracaoExecutor, setAlteracaoexecutor] = useState(false);
  const [novaAlteracaoExecutor, setNovaAlteracaoExecutor] = useState(false);
  const [sqAltExec, setSqAltExec] = useState(0);
  const [quantidadeIncluidos, setQuantidadeIncluidos] = useState(0);
  const [quantidadeExcluidos, setQuantidadeExcluidos] = useState(0);
  const [quantidadeExecutores, setQuantidadeExecutores] = useState(0);
  const { request: salvarRequest, data: salvarData, errors: salvarErrors, isLoading: salvarIsLoading } = useApiClient();
  const [fgLimpar, setFgLimpar] = useState(false);

  const sqAltExecOs = (novo) => {
    if (novo !== undefined) {
      setSqAltExec(novo);
    }
  };

  const fgLimparOs = (novo) => {
    setFgLimpar(novo);
  };

  const ehAlteracaoExecutor = (alteracao) => {
    setAlteracaoexecutor(alteracao);
  };

  const quantidadeIncluidosOs = (quantidade) => {
    setQuantidadeIncluidos(quantidade);
  };

  const quantidadeExcluidosOs = (quantidade) => {
    setQuantidadeExcluidos(quantidade);
  };

  const quantidadeTotalExecutores = (quantidade) => {
    setQuantidadeExecutores(quantidade);
  };

  useEffect(() => {
    if (sqAlteracaoExecutor > 0) {
      setSqAltExec(sqAlteracaoExecutor);
    }
  }, [sqAlteracaoExecutor]);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      if (sqAltExec) {
        setNovaAlteracaoExecutor(false);
        const paramsAlter = {
          sequencialAlteracaoExecutor: sqAltExec,
          listaExecutoresOs: values.listaExecutoresOs,
          textoJustificativa: values.textoJustificativa,
          status: "I",
        };
        salvarRequest(apiRoutes.fiscalizacao.ordemservico.alterarAltExec, paramsAlter);
        setAlteracaoexecutor(false);
      } else {
        setNovaAlteracaoExecutor(true);
        const paramsInsert = {
          sequencialAcaoFiscal: dadosOs.acaoFiscal,
          listaExecutoresOs: values.listaExecutoresOs,
          textoJustificativa: values.textoJustificativa,
          status: "I",
        };
        salvarRequest(apiRoutes.fiscalizacao.ordemservico.incluirAltExecutor, paramsInsert);
      }
    },
  });

  const { assinarAtividade, assinarIsLoading, assinarErrors } = useAssinarAltExecutor({
    dadosOs,
    sqAltExec,
    sgAtividade,
    formik,
  });

  const { excluirAlteracao, excluirIsLoading, excluirErrors, excluirData } = useExcluirAlteracao({ sqAltExec });

  const { setSubmitting, setValues } = formik;

  useEffect(() => {
    if (excluirData?.result) {
      setFgLimpar(true);
      limparTela(true);
    }
  }, [excluirData, limparTela]);

  useEffect(() => {
    if (salvarIsLoading) return;

    if (!salvarData && !salvarErrors) return;

    if (salvarData) {
      toast.success(`Alteração de Executor cadastrada com sucesso.`);
      setSqAltExec(salvarData.result.sequencialAlteracaoExecutor);
      setAlteracaoexecutor(true);
    } else {
      setAlteracaoexecutor(false);
    }

    setSubmitting(false);
  }, [salvarData, salvarErrors, salvarIsLoading, setSubmitting, setAlteracaoexecutor]);

  useEffect(() => {
    const justificativa =
      salvarData?.result.textoJustificativa.length > 0
        ? salvarData?.result.textoJustificativa
        : dadosAltExec[0]?.txJustificativaAtual;

    setValues((curr) => ({
      ...curr,
      textoJustificativa: justificativa,
      totalExecutores: quantidadeExecutores,
      totalExecutoresIncluidos: quantidadeIncluidos,
      totalExecutoresExcluidos: quantidadeExcluidos,
    }));
  }, [
    setValues,
    dadosAltExec,
    dadosAltExec.txJustificativaAtual,
    quantidadeExecutores,
    quantidadeIncluidos,
    quantidadeExcluidos,
    salvarData,
  ]);

  return (
    <>
      <FormAlert
        formik={formik}
        data={salvarData}
        errors={salvarErrors || assinarErrors || excluirErrors}
        isLoading={salvarIsLoading || assinarIsLoading || excluirIsLoading}
        dismissible
      />
      <div className="row">
        <div className="col-lg-12">
          <div className="card shadow">
            <Row className="text-right pt-3">
              <Col>
                <Button
                  variant="primary"
                  className="btn btn-md mr-3"
                  onClick={formik.handleSubmit}
                  disabled={!formik.isValid}
                >
                  Salvar
                </Button>{" "}
                {"   "}
                <Button
                  variant="primary"
                  className="btn btn-md mr-3"
                  disabled={!formik.isValid && quantidadeExcluidos === 0 && quantidadeIncluidos === 0}
                  onClick={() => {
                    assinarAtividade();
                  }}
                >
                  Assinar
                </Button>
                <Button
                  variant="primary"
                  className="btn btn-md mr-3"
                  onClick={() => {
                    excluirAlteracao();
                  }}
                  disabled={quantidadeExcluidos === 0 && quantidadeIncluidos === 0}
                >
                  Excluir
                </Button>
              </Col>
            </Row>
            <div className="card-body">
              <Tabs defaultActiveKey={1} id="tab-geral">
                <Tab
                  eventKey="1"
                  title={
                    <span>
                      <GoAlert color="red" size={15} hidden={!formik.errors.listaExecutoresOs} /> Executores
                    </span>
                  }
                >
                  <ListaAlteracaoExecutor
                    formik={formik}
                    field="listaExecutoresOs"
                    sqAltExec={novaAlteracaoExecutor ? sqAltExec : sqAlteracaoExecutor}
                    acaoFiscal={dadosOs.acaoFiscal}
                    alteracaoExecutor={alteracaoExecutor}
                    ehAlteracaoExecutor={ehAlteracaoExecutor}
                    sqAltExecOs={sqAltExecOs}
                    quantidadeIncluidosOs={quantidadeIncluidosOs}
                    quantidadeExcluidosOs={quantidadeExcluidosOs}
                    quantidadeTotalExecutores={quantidadeTotalExecutores}
                    fgLimpar={fgLimpar}
                    fgLimparOs={fgLimparOs}
                  />
                </Tab>
                <Tab
                  eventKey="2"
                  title={
                    <span>
                      <GoAlert color="red" size={15} hidden={!formik.errors.textoJustificativa} /> Justificativa
                    </span>
                  }
                >
                  <div className="card shadow mb-4">
                    <div className="card-body float-left">
                      <HtmlEditor formik={formik} field="textoJustificativa" />
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TelaAlteraExecutorOs;
